export default "__VITE_ASSET__DUGb90J5__"